import { render, staticRenderFns } from "./BuyersAndRegions.vue?vue&type=template&id=7da155a2&scoped=true"
import script from "./BuyersAndRegions.vue?vue&type=script&lang=ts"
export * from "./BuyersAndRegions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da155a2",
  null
  
)

export default component.exports